import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { map, Observable, tap } from 'rxjs';
import { Cities } from 'src/app/model/cities';
import { Countries } from 'src/app/model/countries';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { LOCALISATIONS } from 'src/app/model/localisations';
import { ProfilDetails } from 'src/app/model/profilDetails';
import { StmdBeneficiary } from 'src/app/model/stmd-beneficiary.model';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { confirmEqualValidator } from 'src/app/modules/shared/validators/confirm-equal';

@Component({
  selector: 'app-stemd-form',
  templateUrl: './stemd-form.component.html',
  styleUrls: ['./stemd-form.component.css'],
})
export class StemdFormComponent {
  countries!: Countries[];
  cities!: Cities[];
  phoneCode!: any[];
  phoneCodeWhatsapp!: any[];

  //Les controls
  prenomCtrl!: FormControl;
  nomCtrl!: FormControl;
  dateDeNaissanceCtrl!: FormControl;
  sexeCtrl!: FormControl;
  numeroCtrl!: FormControl;
  indicatifCtrl!: FormControl;
  estWhatsAppCtrl!: FormControl;
  numeroWhatsAppCtrl!: FormControl;
  indicatifWhatsAppCtrl!: FormControl;
  mailCtrl!: FormControl;
  mailDeConfirmationCtrl!: FormControl;
  motDePasseCtrl!: FormControl;
  confirmMotDePasseCtrl!: FormControl;
  paysCtrl!: FormControl;
  autrePaysCtrl!: FormControl;
  regionCtrl!: FormControl;
  villeCtrl!: FormControl;
  etablissementCtrl!: FormControl;
  classeCtrl!: FormControl;
  serieCtrl!: FormControl;

  //Les forms
  inscriptionForm!: FormGroup;

  soumissionForm!: FormGroup;
  emailForm!: FormGroup;
  passwordForm!: FormGroup;

  diplomes!: any;
  students!: any;
  otherStatus!: any;
  zones!: any;
  regions!: any;
  classes: any[] = [];
  series: any[] = [];

  disciplines: any[] = [];

  isSucces: boolean = false;
  isNotANumber: boolean = false;
  emailMatched: boolean = false;
  typedEmail: string = '';
  checkPageOneFields: boolean = true;

  showWhatsAppNumberFields: boolean = false;
  showOtherCountryField: boolean = false;

  controlsList: string[] = [
    'city',
    'classe',
    'country',
    'dateBirth',
    'emailGroup.email',
    'emailGroup.confirmEmail',
    'establishment',
    'firstname',
    'gender',
    'isWhatsApp',
    'lastname',
    'otherCountry',
    'passwordGroup.password',
    'passwordGroup.confirmPassword',
    'phoneCodeOne',
    'phoneCodeTwo',
    'phoneNumberOne',
    'phoneNumberTwo',
    'region',
    'serie',
  ];

  showEmailErrors$!: Observable<boolean>;
  showPasswordErrors$!: Observable<boolean>;

  showSpinner = false;
  fillAllFields: any;
  showSpecificRegionDiv: boolean = false;
  showZoneDiv: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private backendapiService: AuthService,
    private spinnerService: SpinnerServiceService,
  ) {}

  ngOnInit(): void {
    this.spinnerService.hideSpinner();
    this.initFormVariables();
    this.initControls();
    this.initForms();
    this.initObservables();
  }

  onSubmitForm() {
    if (this.inscriptionForm.invalid) {
      this.controlsList.forEach((control) => {
        this.markInvalidField(control);
      });
      this.fillAllFields = true;
      setTimeout(() => {
        this.fillAllFields = false;
      }, 2500);
    } else {
      this.fillAllFields = false;
      const formValue = this.inscriptionForm.value;
      const mailFormValue = this.emailForm.value;
      const passwordFormValue = this.passwordForm.value;
      // console.log('Inscription form', formValue);

      let right_nationality = '';

      if (formValue['country'] === 'Autre') {
        right_nationality = formValue['otherCountry'];
      } else {
        right_nationality = '';
      }

      const studentInfo: StmdBeneficiary = {
        firstname: formValue['firstname'],
        lastname: formValue['lastname'],
        email: mailFormValue['email'],
        password: passwordFormValue['password'],
        dateBirth: formValue['dateBirth'],
        phoneNumberOne: formValue['phoneCodeOne'] + formValue['phoneNumberOne'],
        phoneNumberTwo: formValue['phoneCodeTwo'] + formValue['phoneNumberTwo'],
        nationalite: formValue['country'],
        right_nationality: right_nationality,
        gender: {
          id: +formValue['gender'],
        },
        profile: { id: 1 },
        roles: { id: 3 },
        country: {
          id: 287,
        },
        city: { id: +formValue['city'] },
        region: formValue['region'],
        etablissement: formValue['establishment'],
        classe: formValue['classe'],
        serie: formValue['serie'],
        niveau: '',
        stemdProfil: 'ELEVE',
      };
      // console.log('Object to send:', studentInfo);

      this.backendapiService
        .stemdInscription(studentInfo)
        .pipe(
          tap((response) => {
            // console.log('Reponse inscription:', response);
            if (response.status === 200) {
              this.isSucces = true;
              setTimeout(() => {
                this.isSucces = false;
                window.scrollTo(0, 0);
              }, 2500);
            }
          }),
        )
        .subscribe();
    }
  }

  markInvalidField(controlName: string) {
    const control = this.inscriptionForm.get(controlName);

    if (control && control.invalid) {
      control.markAsTouched();
    }
  }

  isFieldInvalid(controlName: string): boolean | null {
    const control = this.inscriptionForm.get(controlName);

    return control && control.invalid && control.touched;
  }

  isFieldInvalidForMails(controlName: string): boolean | null {
    const control = this.inscriptionForm.get(controlName);

    return control && control.errors?.['required'] && control.touched;
  }

  isMailFieldInvalid(control: string): boolean | null {
    return (
      this.emailForm.get(control)?.errors?.['email'] &&
      this.emailForm.get(control)?.touched
    );
  }

  isPasswordFieldInvalid(control: string) {
    // console.log('pattern error:', this.passwordForm.get(control)?.errors);
    return (
      this.passwordForm.get(control)?.errors?.['pattern'] &&
      this.passwordForm.get(control)?.touched
    );
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  checkPageOneValidity(controls: string[]) {
    if (this.showWhatsAppNumberFields) {
      controls.push('whatsAppNumber');
      controls.push('phoneCodeForWhatsApp');
    }
    /*********************************************************************/

    controls.forEach((control) => {
      //console.log(control, ': ', this.soumissionForm.get(control)?.valid);
      if (this.soumissionForm.get(control)?.invalid) {
        this.checkPageOneFields = false;
      }
    });

    //Marquage en rouge des champs non remplis

    if (this.checkPageOneFields === false) {
      controls.forEach((control) => {
        this.markInvalidField(control);
      });
    }
  }
  showSpecifyDiv() {
    this.soumissionForm
      .get('selectedRegion')
      ?.valueChanges.subscribe((region) => {
        if (region == 15) {
          this.showSpecificRegionDiv = true;
          this.soumissionForm.removeControl('selectedZone');
        } else {
          this.showSpecificRegionDiv = false;
        }
      });

    return this.showSpecificRegionDiv;
  }

  showZoneOfResidenceDiv() {
    if (this.showSpecificRegionDiv) {
      this.showZoneDiv = false;
    } else {
      this.showZoneDiv = true;
      this.soumissionForm.addControl(
        'selectedZone',
        this.formBuilder.control(null, Validators.required),
      );
    }
    return this.showZoneDiv;
  }

  private initObservables() {
    this.paysCtrl.valueChanges.subscribe((nationalité) => {
      if (nationalité === 'Autre') {
        this.showOtherCountryField = true;
        this.autrePaysCtrl.addValidators(Validators.required);
      } else {
        this.showOtherCountryField = false;
        this.autrePaysCtrl.clearValidators();
      }
    });

    this.estWhatsAppCtrl?.valueChanges.subscribe((isWhatsApp) => {
      if (isWhatsApp === 'NON') {
        this.showWhatsAppNumberFields = true;
        this.numeroCtrl.addValidators(Validators.required);
        this.indicatifCtrl.addValidators(Validators.required);
      } else {
        this.showWhatsAppNumberFields = false;
        this.numeroCtrl.patchValue('');
        this.numeroCtrl.clearValidators();
        this.indicatifCtrl.clearValidators();
      }
    });

    this.showEmailErrors$ = this.emailForm.statusChanges.pipe(
      map(
        (status) =>
          status === 'INVALID' &&
          this.emailForm.get('email')?.value &&
          this.emailForm.get('confirmEmail')?.value,
      ),
    );

    this.showPasswordErrors$ = this.passwordForm.statusChanges.pipe(
      map(
        (status) =>
          status === 'INVALID' &&
          this.passwordForm.get('password')?.value &&
          this.passwordForm.get('confirmPassword')?.value,
      ),
    );

    this.paysCtrl?.valueChanges.subscribe((values) => {
      if (values === 'Autre') {
        this.inscriptionForm.addControl(
          'otherCountry',
          this.formBuilder.control(null, Validators.required),
        );
        this.controlsList.push('otherCountry');
      } else {
        this.inscriptionForm.removeControl('otherCountry');
        this.controlsList = this.controlsList.filter(
          (e) => e !== 'otherCountry',
        );
      }
    });
  }
  private initControls() {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\*\-#])[A-Za-z\d\*\-#]{8,}$/;

    this.prenomCtrl = this.formBuilder.control('', Validators.required);
    this.nomCtrl = this.formBuilder.control('', Validators.required);
    this.dateDeNaissanceCtrl = this.formBuilder.control(
      '',
      Validators.required,
    );
    this.sexeCtrl = this.formBuilder.control('', Validators.required);
    this.indicatifCtrl = this.formBuilder.control('221', Validators.required);
    this.estWhatsAppCtrl = this.formBuilder.control(null, Validators.required);
    this.numeroWhatsAppCtrl = this.formBuilder.control('', Validators.required);
    this.indicatifWhatsAppCtrl = this.formBuilder.control(
      '221',
      Validators.required,
    );
    this.numeroCtrl = this.formBuilder.control('');
    this.indicatifCtrl = this.formBuilder.control('221');
    this.mailCtrl = this.formBuilder.control('', Validators.required);
    this.mailDeConfirmationCtrl = this.formBuilder.control(
      '',
      Validators.required,
    );
    this.motDePasseCtrl = this.formBuilder.control('', [
      Validators.required,
      Validators.pattern(passwordRegex),
    ]);
    this.confirmMotDePasseCtrl = this.formBuilder.control('', [
      Validators.required,
      Validators.pattern(passwordRegex),
    ]);
    this.paysCtrl = this.formBuilder.control('', Validators.required);
    this.autrePaysCtrl = this.formBuilder.control('');
    this.regionCtrl = this.formBuilder.control('', Validators.required);
    this.villeCtrl = this.formBuilder.control('', Validators.required);
    this.etablissementCtrl = this.formBuilder.control('', Validators.required);
    this.classeCtrl = this.formBuilder.control('', Validators.required);
    this.serieCtrl = this.formBuilder.control('', Validators.required);
  }
  private initForms() {
    this.emailForm = this.formBuilder.group(
      {
        email: [null, [Validators.required, Validators.email]],
        confirmEmail: [null, [Validators.required, Validators.email]],
      },
      {
        validators: [confirmEqualValidator('email', 'confirmEmail')],
      },
    );

    this.passwordForm = this.formBuilder.group(
      {
        password: this.motDePasseCtrl,
        confirmPassword: this.confirmMotDePasseCtrl,
      },
      {
        validators: [confirmEqualValidator('password', 'confirmPassword')],
      },
    );
    this.inscriptionForm = this.formBuilder.group({
      firstname: this.prenomCtrl,
      lastname: this.nomCtrl,
      dateBirth: this.dateDeNaissanceCtrl,
      gender: this.sexeCtrl,
      city: this.villeCtrl,
      country: this.paysCtrl,
      otherCountry: this.autrePaysCtrl,
      region: this.regionCtrl,
      emailGroup: this.emailForm,
      isWhatsApp: this.estWhatsAppCtrl,
      phoneNumberOne: this.numeroWhatsAppCtrl,
      phoneCodeOne: this.indicatifWhatsAppCtrl,
      phoneNumberTwo: this.numeroCtrl,
      phoneCodeTwo: this.indicatifCtrl,
      passwordGroup: this.passwordForm,
      establishment: this.etablissementCtrl,
      classe: this.classeCtrl,
      serie: this.serieCtrl,
    });
  }

  private initFormVariables() {
    this.backendapiService.getCountries().subscribe((data) => {
      this.countries = data.sort((c, d) => (c.name < d.name ? -1 : 1));
    });
    this.backendapiService.getCountries().subscribe((data) => {
      this.phoneCode = data.sort((c, d) => c.phoneCode - d.phoneCode);
      this.phoneCodeWhatsapp = this.phoneCode;
    });

    this.backendapiService.getCities().subscribe((villes) => {
      // console.log('les villes', villes);
      this.cities = villes;
    });

    this.zones = LOCALISATIONS.Zones;
    this.regions = LOCALISATIONS.Regions;

    this.series = ProfilDetails.Série4Stemd;
    this.classes = ProfilDetails.Classe4Stemd;
  }
}
